import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  AutomotiveAftermarketFiltersInitialState,
  AutomotiveAftermarketFiltersLoad,
  AutomotiveAftermarketFiltersUpdate,
} from './automotive-aftermarket-filters.actions';
import { AutomotiveAftermarketFiltersState } from './automotive-aftermarket-filters.state';
import { MonitoringFilterNameDictionary } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class AutomotiveAftermarketFiltersFacade implements LoadDataFacade, SetInitialStateFacade {
  items$: Observable<MonitoringFilterNameDictionary[]> = this.store.select(AutomotiveAftermarketFiltersState.getItems);
  loaded$: Observable<boolean> = this.store.select(AutomotiveAftermarketFiltersState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AutomotiveAftermarketFiltersLoad());
  }

  updateFilters(filters: MonitoringFilterNameDictionary[]): void {
    this.store.dispatch(new AutomotiveAftermarketFiltersUpdate(filters));
  }

  setInitialState(): void {
    this.store.dispatch(new AutomotiveAftermarketFiltersInitialState());
  }
}
